import { PRIVACY_URL, COOKIE_URL, CONTACT_EMAIL } from "@/lib/i18n";
import { Wordmark } from "@/components/home/Wordmark";

const Sep = () => <span className="sep" aria-hidden="true">·</span>;

export const SiteFooter = ({ t }) => (
  <footer data-testid="site-footer">
    <span className="copy">© 2026<img src="/logo-symbol.png" alt="" aria-hidden="true" width="62" height="64" className="footer-symbol" data-testid="footer-logo-symbol" /><Wordmark /></span><Sep />
    <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-privacy-link">{t.privacy}</a><Sep />
    <a href={COOKIE_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-cookie-link">{t.cookiePolicy}</a><Sep />
    <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-contact-link">{t.contact}</a><Sep />
    <a href="#" className="iubenda-cs-preferences-link" onClick={(e) => e.preventDefault()} data-testid="footer-cookie-prefs-link">
      {t.cookiePrefs}
    </a>
  </footer>
);
